import { AxiosResponse } from 'axios'

export class ValidationMessage {
  property?: string
  message?: string
}

export class ValidationResults {
  errors?: ValidationMessage[]
  warnings?: ValidationMessage[]
  information?: ValidationMessage[]
}

export class ValidationQueryResult {
  message?: string
  details?: ValidationResults
}

export class APIError<T> {
  message?: string
  response?: AxiosResponse<T>
}
